import { useState } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface DevTestChecklistProps {
  devTabsVisible?: boolean;
  previewButtonVisible?: boolean;
  previewLineButtonVisible?: boolean;
  tabsVisible?: boolean;
  simulateMatrizWorking?: boolean;
}

/**
 * Checklist de teste manual para DEV Preview
 * 
 * Permite validar em 2 minutos se tudo está funcionando
 */
export default function DevTestChecklist({
  devTabsVisible = true,
  previewButtonVisible = true,
  previewLineButtonVisible = true,
  tabsVisible = true,
  simulateMatrizWorking = true,
}: DevTestChecklistProps) {
  const [checks, setChecks] = useState({
    badge: devTabsVisible,
    previewButton: previewButtonVisible,
    previewLine: previewLineButtonVisible,
    tabs: tabsVisible,
    simulateMatriz: simulateMatrizWorking,
  });

  const handleCheck = (key: keyof typeof checks) => {
    setChecks((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const allChecked = Object.values(checks).every((v) => v);

  const items = [
    {
      key: "badge",
      label: "DEV badge visível no canto inferior direito",
      description: "Amarelo/laranja com 'DEV TABS: ON'",
    },
    {
      key: "previewButton",
      label: "Botão 'Preview Abas (DEV)' abre drawer",
      description: "Sem depender de editar cliente",
    },
    {
      key: "previewLine",
      label: "Botão 'Preview' em cada linha abre com dados",
      description: "Mostra id + nome + cnpj do cliente",
    },
    {
      key: "tabs",
      label: "Tabs aparecem no drawer",
      description: "Visão Geral + Matriz e Filiais",
    },
    {
      key: "simulateMatriz",
      label: "Toggle 'Simular Matriz' habilita UI de filial",
      description: "Botão '+ Adicionar Filial' aparece",
    },
  ];

  return (
    <Card className="border-blue-300 bg-blue-50">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-bold text-blue-900">
          🧪 Checklist de Teste Manual (DEV)
        </CardTitle>
        <p className="text-xs text-blue-700 mt-1">
          Valide tudo em 2 minutos
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        {items.map((item) => (
          <div key={item.key} className="flex items-start gap-3">
            <Checkbox
              checked={checks[item.key as keyof typeof checks]}
              onCheckedChange={() =>
                handleCheck(item.key as keyof typeof checks)
              }
              className="mt-1"
            />
            <div className="flex-1">
              <label className="text-sm font-medium text-gray-900 cursor-pointer">
                {item.label}
              </label>
              <p className="text-xs text-gray-600">{item.description}</p>
            </div>
          </div>
        ))}

        {allChecked && (
          <div className="mt-4 p-3 bg-green-100 border border-green-300 rounded text-sm text-green-900 font-semibold">
            ✅ Todos os testes passaram! DEV Preview está 100% funcional.
          </div>
        )}
      </CardContent>
    </Card>
  );
}
